var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialImpressionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3 38.37C7.42 39.14 13.28 42.69 25.55 45.03C37.81 47.37 43.02 66.48 46.84 41.49C48.42 31.11 38.08 30.13 31.24 26.58C24.4 23.03 39.48 18.6 39.48 18.6M108.99 93.63C120.65 76.44 122.67 53.54 112.29 33.9C97.31 5.58 62.21 -5.23001 33.9 9.73999C24.24 14.85 16.61 22.3 11.35 31.03M4.61 47.47C1.43 60.72 2.87 75.13 9.74 88.13C24.71 116.45 59.81 127.26 88.13 112.29C91.46 110.53 94.55 108.48 97.39 106.21M106.43 102C106.43 102 96.93 96.61 89.2 92.42C81.47 88.24 63.96 94.74 57.27 97.73C50.58 100.72 38.29 97.29 41.84 90.45C45.39 83.61 63.61 79.49 62.78 71.66C61.95 63.83 54.15 56.38 60.84 53.39C67.53 50.4 88.96 62.78 82.13 49.85C75.29 36.92 68.48 43.84 63.51 36.54C58.55 29.24 56.75 17.51 55.36 13.83C53.97 10.16 51.23 3.10999 51.23 3.10999",
    stroke: "#164361",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.02,
    height: 122.02,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialImpressionIcon);
export default __webpack_public_path__ + "static/media/social-impression-icon.8635b5fed6c71cea1c0a7e754b1e8020.svg";
export { ForwardRef as ReactComponent };